import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-fintech',
  templateUrl: './fintech.component.html',
  styleUrls: ['./fintech.component.css']
})
export class FintechComponent implements OnInit {
   brandSelect = 'bsi';

  constructor() { }

  ngOnInit(): void {
  }

}
